<template>
	<div class="cabecalho">
		<div class="informacoes">
			<div class="informacao">
				<span class="titulo">Nº Ata</span>
				<span class="valor">{{ (anuencia || {}).numeroAta }}</span>
			</div>
			<div class="informacao">
				<span class="titulo">Órgão</span>
				<span class="valor">{{ (anuencia || {}).orgaoSigla }}</span>
			</div>
			<div class="informacao">
				<span class="titulo">Vigência</span>
				<span class="valor">{{ getTextoVigencias() }}</span>
			</div>
		</div>
		<div v-if="jaMudouSituacao" class="acoes">
			<v-btn outlined color="white" :block="ehMobile" @click="$emit('abrir-modal-recusar', $event)"
				>Recusar</v-btn
			>
			<v-btn outlined color="white" :block="ehMobile" @click="$emit('aceitar-itens', $event)">Aceitar</v-btn>
		</div>

		<div v-if="isGerarDocumento" class="acoes">
			<v-btn data-testid="gerar-documento" outlined color="white" :block="ehMobile" @click="$emit('gerar-documento', $event)"
				>Gerar Documento</v-btn
			>
		</div>
	</div>
</template>
<script>
import formatDataFilter from '@/views/filters/format-data-filter'
import { situacoes } from '@/core/constants'

export default {
	name: 'cabecalho-anuencia',
	props: {
		anuencia: {
			type: Object,
			required: true,
		},
	},
	computed: {
		isGerarDocumento() {
			return this.anuencia.isDocumentoGeradoErro
		},
		estaAceito() {
			return this.anuencia.situacaoItemAdesao === situacoes.ADESAO.ACEITO.value
		},
		estaRecusada() {
			return this.anuencia.situacaoItemAdesao === situacoes.ADESAO.RECUSADO.value
		},
		estaFinalizada() {
			return this.anuencia.situacaoItemAdesao === situacoes.ADESAO.CONCLUIDO.value
		},
		estaAssinado() {
			return this.anuencia.situacaoItemAdesao === situacoes.ADESAO.ASSINADO.value
		},
		jaMudouSituacao() {
			return !(this.estaAceito || this.estaRecusada || this.estaFinalizada || this.estaAssinado)
		},
	},
	methods: {
		getTextoVigencias() {
			let inicioVigencia = formatDataFilter(this.anuencia.dataInicioVigencia)
			let fimVigencia = formatDataFilter(this.anuencia.dataFinalVigencia)
			return `${inicioVigencia} - ${fimVigencia}`
		},
	},
}
</script>
<style scoped lang="stylus">
.cabecalho
	color white
	background-color var(--v-primary-base)
	display flex
	justify-content start
	padding 20px
	border-radius 10px 10px 0 0

	.informacoes
		display flex
		flex-direction row
		justify-content flex-start
		gap 50px
		flex-wrap wrap
		width 70%

		.informacao
			display flex
			flex-direction column

			.titulo
				font-weight bold
				font-size 0.75em

			.valor
				font-size 0.8em

	.acoes
		width 30%
		display flex
		flex-direction row
		justify-content flex-end
		gap 20px

@media screen and (max-width: 768px)
	.cabecalho
		display flex
		flex-direction column
		height auto

		.informacoes
			display flex
			flex-direction column
			width 100%
			height auto
			font-size 1.8em
			align-items flex-start
			align-content stretch
			gap 10px

		.acoes
			display flex
			flex-direction column
			width 100%
			height auto
			jusfity-content center
			heigth auto
			justify-items center
</style>
